import { TenantPerformableFormProps } from '~/tenants/common/form';
import { MpiOrderContext } from '../../model/MpiOrder';
import { GalleryExamples } from '~/tenants/common/package';

export default function MpiFloorplanForm({ persona }: TenantPerformableFormProps<MpiOrderContext>) {
  // TODO: Joel: Need to replace with correct images
  return <GalleryExamples name="test" images={['tenant/twt/residential/1.jpg']} persona={persona} />;
}
